import { createParser, useQueryState } from "nuqs";
import { removeEmptyValues } from "../utils";

export interface SerializableObject {
  [key: string]: any;
}

export const base64Parser = (
  queryValue: string,
  omitProperties?: string[],
): SerializableObject => {
  try {
    const jsonString = Buffer.from(queryValue, "base64").toString("utf-8");
    const obj = JSON.parse(jsonString) as SerializableObject;
    if (omitProperties) {
      for (const prop of omitProperties) {
        delete obj[prop];
      }
    }
    return obj as SerializableObject;
  } catch (error: any) {
    // console.error(`Errore durante il parsing: ${error.message}`);
    return {};
  }
};

export const base64Serializer = (value: SerializableObject): string => {
  try {
    const cleanedValue = removeEmptyValues(value);
    const jsonString = JSON.stringify(cleanedValue);
    return Buffer.from(jsonString).toString("base64");
  } catch (error: any) {
    console.error(`Errore durante la serializzazione: ${error.message}`);
    return "";
  }
};

export const nuqsBase64Parser = createParser({
  parse(queryValue: string): SerializableObject | null {
    return base64Parser(queryValue);
  },
  serialize(value: SerializableObject): string {
    return base64Serializer(value);
  },
});

export function useBase64QueryState<T>(
  defaultValue?: any | null,
  options?: any,
  defaultName?: string,
) {
  let _options = {
    ...options,
    ...nuqsBase64Parser,
  };

  if (defaultValue) {
    _options.defaultValue = defaultValue;
  }

  return useQueryState<T | any>(defaultName || "d", _options);
}
